// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz__FinishedQuiz___2wZlN","success":"FinishedQuiz__success___2QtOd","error":"FinishedQuiz__error___3yLIP"};